export default "__VITE_ASSET__BOnHsriO__"